// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_3eU","cls2":"AppsMegaMenu-cls2_FG0 AppsMegaMenu-cls1_3eU"};